// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AbsolutePickerController from "./absolute_picker_controller"
application.register("absolute-picker", AbsolutePickerController)

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import AnnouncementController from "./announcement_controller"
application.register("announcement", AnnouncementController)

import AutoSaveController from "./auto_save_controller"
application.register("auto-save", AutoSaveController)

import AutocompleteController from "./autocomplete_controller"
application.register("autocomplete", AutocompleteController)

import BannerController from "./banner_controller"
application.register("banner", BannerController)

import BlurController from "./blur_controller"
application.register("blur", BlurController)

import BudgetDatesController from "./budget_dates_controller"
application.register("budget-dates", BudgetDatesController)

import CaffeineController from "./caffeine_controller"
application.register("caffeine", CaffeineController)

import Calc__RowController from "./calc/row_controller"
application.register("calc--row", Calc__RowController)

import CalcController from "./calc_controller"
application.register("calc", CalcController)

import Charts__SankeyController from "./charts/sankey_controller"
application.register("charts--sankey", Charts__SankeyController)

import ChatController from "./chat_controller"
application.register("chat", ChatController)

import ChildSelectableController from "./child_selectable_controller"
application.register("child-selectable", ChildSelectableController)

import ClearFieldsController from "./clear_fields_controller"
application.register("clear-fields", ClearFieldsController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CmdPaletteController from "./cmd_palette_controller"
application.register("cmd-palette", CmdPaletteController)

import CohortTblController from "./cohort_tbl_controller"
application.register("cohort-tbl", CohortTblController)

import ComboboxController from "./combobox_controller"
application.register("combobox", ComboboxController)

import CompactPickerController from "./compact_picker_controller"
application.register("compact-picker", CompactPickerController)

import Configs__FormController from "./configs/form_controller"
application.register("configs--form", Configs__FormController)

import Configs__PresetsController from "./configs/presets_controller"
application.register("configs--presets", Configs__PresetsController)

import Configs__RangeController from "./configs/range_controller"
application.register("configs--range", Configs__RangeController)

import Configs__RangeSetController from "./configs/range_set_controller"
application.register("configs--range-set", Configs__RangeSetController)

import Credit__CostController from "./credit/cost_controller"
application.register("credit--cost", Credit__CostController)

import Credit__OrderController from "./credit/order_controller"
application.register("credit--order", Credit__OrderController)

import DashboardsController from "./dashboards_controller"
application.register("dashboards", DashboardsController)

import DateFieldController from "./date_field_controller"
application.register("date-field", DateFieldController)

import DatePresetController from "./date_preset_controller"
application.register("date-preset", DatePresetController)

import DateRangeController from "./date_range_controller"
application.register("date-range", DateRangeController)

import DeduplicatorController from "./deduplicator_controller"
application.register("deduplicator", DeduplicatorController)

import DelayableController from "./delayable_controller"
application.register("delayable", DelayableController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import DisableController from "./disable_controller"
application.register("disable", DisableController)

import DispatchController from "./dispatch_controller"
application.register("dispatch", DispatchController)

import DocBlocksController from "./doc_blocks_controller"
application.register("doc-blocks", DocBlocksController)

import DocsController from "./docs_controller"
application.register("docs", DocsController)

import DollarFieldController from "./dollar_field_controller"
application.register("dollar-field", DollarFieldController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import DynamicPickerController from "./dynamic_picker_controller"
application.register("dynamic-picker", DynamicPickerController)

import EmailBatchesController from "./email_batches_controller"
application.register("email-batches", EmailBatchesController)

import EmailSeriesStepController from "./email_series_step_controller"
application.register("email-series-step", EmailSeriesStepController)

import EmbedsController from "./embeds_controller"
application.register("embeds", EmbedsController)

import FancyPickerController from "./fancy_picker_controller"
application.register("fancy-picker", FancyPickerController)

import FlatpickrClearController from "./flatpickr_clear_controller"
application.register("flatpickr-clear", FlatpickrClearController)

import FlatpickrController from "./flatpickr_controller"
application.register("flatpickr", FlatpickrController)

import FlatpickrRangeController from "./flatpickr_range_controller"
application.register("flatpickr-range", FlatpickrRangeController)

import FlatpickrTimeController from "./flatpickr_time_controller"
application.register("flatpickr-time", FlatpickrTimeController)

import FormDisableController from "./form_disable_controller"
application.register("form-disable", FormDisableController)

import FrameReloadController from "./frame_reload_controller"
application.register("frame-reload", FrameReloadController)

import FrameSearchController from "./frame_search_controller"
application.register("frame-search", FrameSearchController)

import FrameStateController from "./frame_state_controller"
application.register("frame-state", FrameStateController)

import FundDataController from "./fund_data_controller"
application.register("fund-data", FundDataController)

import GaugeController from "./gauge_controller"
application.register("gauge", GaugeController)

import GraphController from "./graph_controller"
application.register("graph", GraphController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import Households__NameBoxController from "./households/name_box_controller"
application.register("households--name-box", Households__NameBoxController)

import Households__PageController from "./households/page_controller"
application.register("households--page", Households__PageController)

import Hq__Data__CardAlertController from "./hq/data/card_alert_controller"
application.register("hq--data--card-alert", Hq__Data__CardAlertController)

import Hq__NavController from "./hq/nav_controller"
application.register("hq--nav", Hq__NavController)

import HtmlPreviewController from "./html_preview_controller"
application.register("html-preview", HtmlPreviewController)

import InlinePickerController from "./inline_picker_controller"
application.register("inline-picker", InlinePickerController)

import LabelFormController from "./label_form_controller"
application.register("label-form", LabelFormController)

import LabelMaskController from "./label_mask_controller"
application.register("label-mask", LabelMaskController)

import LandingFormController from "./landing_form_controller"
application.register("landing-form", LandingFormController)

import LeaderController from "./leader_controller"
application.register("leader", LeaderController)

import ListMemberCountsController from "./list_member_counts_controller"
application.register("list-member-counts", ListMemberCountsController)

import ListboxController from "./listbox_controller"
application.register("listbox", ListboxController)

import Lists__CopiesController from "./lists/copies_controller"
application.register("lists--copies", Lists__CopiesController)

import MapController from "./map_controller"
application.register("map", MapController)

import Maps__CompaniesController from "./maps/companies_controller"
application.register("maps--companies", Maps__CompaniesController)

import Maps__HouseholdsController from "./maps/households_controller"
application.register("maps--households", Maps__HouseholdsController)

import Maps__IsochroneController from "./maps/isochrone_controller"
application.register("maps--isochrone", Maps__IsochroneController)

import Maps__SearchesController from "./maps/searches_controller"
application.register("maps--searches", Maps__SearchesController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import MonthlyPercentagesController from "./monthly_percentages_controller"
application.register("monthly-percentages", MonthlyPercentagesController)

import MultiChartController from "./multi_chart_controller"
application.register("multi-chart", MultiChartController)

import Nested__DestroyableController from "./nested/destroyable_controller"
application.register("nested--destroyable", Nested__DestroyableController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import OverlayController from "./overlay_controller"
application.register("overlay", OverlayController)

import PageController from "./page_controller"
application.register("page", PageController)

import PasswordStrengthController from "./password_strength_controller"
application.register("password-strength", PasswordStrengthController)

import PeriodManagerController from "./period_manager_controller"
application.register("period-manager", PeriodManagerController)

import Perms__RowController from "./perms/row_controller"
application.register("perms--row", Perms__RowController)

import PillboxController from "./pillbox_controller"
application.register("pillbox", PillboxController)

import PopManagerController from "./pop_manager_controller"
application.register("pop-manager", PopManagerController)

import PopoverController from "./popover_controller"
application.register("popover", PopoverController)

import RangePresetController from "./range_preset_controller"
application.register("range-preset", RangePresetController)

import RangeSummaryController from "./range_summary_controller"
application.register("range-summary", RangeSummaryController)

import ReactorController from "./reactor_controller"
application.register("reactor", ReactorController)

import RelativePickerController from "./relative_picker_controller"
application.register("relative-picker", RelativePickerController)

import ScenarioController from "./scenario_controller"
application.register("scenario", ScenarioController)

import Scenarios__ComparisonController from "./scenarios/comparison_controller"
application.register("scenarios--comparison", Scenarios__ComparisonController)

import Scenarios__FlatpickrController from "./scenarios/flatpickr_controller"
application.register("scenarios--flatpickr", Scenarios__FlatpickrController)

import Scenarios__GroupController from "./scenarios/group_controller"
application.register("scenarios--group", Scenarios__GroupController)

import Scenarios__LeaderController from "./scenarios/leader_controller"
application.register("scenarios--leader", Scenarios__LeaderController)

import Scenarios__RangeController from "./scenarios/range_controller"
application.register("scenarios--range", Scenarios__RangeController)

import ScreeningListsController from "./screening_lists_controller"
application.register("screening-lists", ScreeningListsController)

import ScrollHintController from "./scroll_hint_controller"
application.register("scroll-hint", ScrollHintController)

import ScrollWatchController from "./scroll_watch_controller"
application.register("scroll-watch", ScrollWatchController)

import Searches__DateSummaryController from "./searches/date_summary_controller"
application.register("searches--date-summary", Searches__DateSummaryController)

import Searches__FundSummaryController from "./searches/fund_summary_controller"
application.register("searches--fund-summary", Searches__FundSummaryController)

import Searches__LocationSummaryController from "./searches/location_summary_controller"
application.register("searches--location-summary", Searches__LocationSummaryController)

import Searches__SortHeadingsController from "./searches/sort_headings_controller"
application.register("searches--sort-headings", Searches__SortHeadingsController)

import SelectableController from "./selectable_controller"
application.register("selectable", SelectableController)

import SelectionController from "./selection_controller"
application.register("selection", SelectionController)

import Settings__AiAssistantController from "./settings/ai_assistant_controller"
application.register("settings--ai-assistant", Settings__AiAssistantController)

import SingleSelectController from "./single_select_controller"
application.register("single-select", SingleSelectController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import StreamController from "./stream_controller"
application.register("stream", StreamController)

import Stripe__BankController from "./stripe/bank_controller"
application.register("stripe--bank", Stripe__BankController)

import Stripe__CardController from "./stripe/card_controller"
application.register("stripe--card", Stripe__CardController)

import Stripe__LoaderController from "./stripe/loader_controller"
application.register("stripe--loader", Stripe__LoaderController)

import Stripe__MandatesController from "./stripe/mandates_controller"
application.register("stripe--mandates", Stripe__MandatesController)

import TabSwitchController from "./tab_switch_controller"
application.register("tab-switch", TabSwitchController)

import TableSelectController from "./table_select_controller"
application.register("table-select", TableSelectController)

import TablesortController from "./tablesort_controller"
application.register("tablesort", TablesortController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TaggingRules__EntityTypeAttributesController from "./tagging_rules/entity_type_attributes_controller"
application.register("tagging-rules--entity-type-attributes", TaggingRules__EntityTypeAttributesController)

import TaggingRules__ModeCardController from "./tagging_rules/mode_card_controller"
application.register("tagging-rules--mode-card", TaggingRules__ModeCardController)

import TaggingRules__ScopeController from "./tagging_rules/scope_controller"
application.register("tagging-rules--scope", TaggingRules__ScopeController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import Tours__AttendanceController from "./tours/attendance_controller"
application.register("tours--attendance", Tours__AttendanceController)

import Tours__AttendanceSetupController from "./tours/attendance_setup_controller"
application.register("tours--attendance-setup", Tours__AttendanceSetupController)

import Tours__EmailSeriesController from "./tours/email_series_controller"
application.register("tours--email-series", Tours__EmailSeriesController)

import Tracker__MonthlyAdjController from "./tracker/monthly_adj_controller"
application.register("tracker--monthly-adj", Tracker__MonthlyAdjController)

import Tracker__SegmentAdjController from "./tracker/segment_adj_controller"
application.register("tracker--segment-adj", Tracker__SegmentAdjController)

import TriggerFormController from "./trigger_form_controller"
application.register("trigger-form", TriggerFormController)

import Ui__AnalyticsController from "./ui/analytics_controller"
application.register("ui--analytics", Ui__AnalyticsController)

import Ui__DraggableController from "./ui/draggable_controller"
application.register("ui--draggable", Ui__DraggableController)

import Ui__PresenceController from "./ui/presence_controller"
application.register("ui--presence", Ui__PresenceController)

import Ui__ResetableController from "./ui/resetable_controller"
application.register("ui--resetable", Ui__ResetableController)

import Ui__ToastController from "./ui/toast_controller"
application.register("ui--toast", Ui__ToastController)

import UiController from "./ui_controller"
application.register("ui", UiController)

import Utils__AutofocusController from "./utils/autofocus_controller"
application.register("utils--autofocus", Utils__AutofocusController)

import Utils__ConfirmController from "./utils/confirm_controller"
application.register("utils--confirm", Utils__ConfirmController)

import Utils__FormSubmitController from "./utils/form_submit_controller"
application.register("utils--form-submit", Utils__FormSubmitController)

import Utils__ModalController from "./utils/modal_controller"
application.register("utils--modal", Utils__ModalController)

import Utils__ToggleController from "./utils/toggle_controller"
application.register("utils--toggle", Utils__ToggleController)

import Utils__TooltipController from "./utils/tooltip_controller"
application.register("utils--tooltip", Utils__TooltipController)

import Utils__TotalsController from "./utils/totals_controller"
application.register("utils--totals", Utils__TotalsController)

import WorkflowController from "./workflow_controller"
application.register("workflow", WorkflowController)

import Workflows__DropzoneController from "./workflows/dropzone_controller"
application.register("workflows--dropzone", Workflows__DropzoneController)

import Workflows__FormController from "./workflows/form_controller"
application.register("workflows--form", Workflows__FormController)

import Workflows__StepController from "./workflows/step_controller"
application.register("workflows--step", Workflows__StepController)
